import React from 'react';
import { Container, Header, Segment } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import Quote from '../../components/Quote';
import StorySection from '../../components/StorySection';
import ImageCarousel from '../../components/ImageCarousel';
import PetalRain from '../../components/PetalRain';
import WeddingDivider from '../../components/WeddingDivider';
import './styles.css';

const heroImage = `${process.env.PUBLIC_URL}/imgs/hero2.jpg`;
const storyImage = `${process.env.PUBLIC_URL}/imgs/story-1.jpg`;
const carrouselImages = [
  `${process.env.PUBLIC_URL}/imgs/carrousel-1.jpg`,
  `${process.env.PUBLIC_URL}/imgs/carrousel-2.jpg`,
  `${process.env.PUBLIC_URL}/imgs/carrousel-3.jpg`,
  `${process.env.PUBLIC_URL}/imgs/carrousel-4.jpg`,
  `${process.env.PUBLIC_URL}/imgs/carrousel-5.jpg`,
  `${process.env.PUBLIC_URL}/imgs/carrousel-6.jpg`,
  `${process.env.PUBLIC_URL}/imgs/carrousel-7.jpg`,
  `${process.env.PUBLIC_URL}/imgs/carrousel-8.jpg`,
  `${process.env.PUBLIC_URL}/imgs/carrousel-9.jpg`,
  `${process.env.PUBLIC_URL}/imgs/carrousel-10.jpg`,
  `${process.env.PUBLIC_URL}/imgs/carrousel-11.jpg`,
  `${process.env.PUBLIC_URL}/imgs/carrousel-12.jpg`,
  `${process.env.PUBLIC_URL}/imgs/carrousel-13.jpg`,
  `${process.env.PUBLIC_URL}/imgs/carrousel-14.jpeg`,
  `${process.env.PUBLIC_URL}/imgs/carrousel-15.jpg`,
  `${process.env.PUBLIC_URL}/imgs/carrousel-16.jpg`
];

function Nosotros() {
  const { t } = useTranslation();
  
  // Array de imágenes para el carousel
  const carouselImages = [
    {
      url: carrouselImages[0],
      caption: t('nosotros.carousel.img1.caption'),
      hoverText: t('nosotros.carousel.img1.hoverText'),
      hoverDate: t('nosotros.carousel.img1.hoverDate')
    },
    {
      url: carrouselImages[1],
      caption: t('nosotros.carousel.img2.caption'),
      hoverText: t('nosotros.carousel.img2.hoverText'),
      hoverDate: t('nosotros.carousel.img2.hoverDate')
    },
    {
      url: carrouselImages[2],
      caption: t('nosotros.carousel.img3.caption'),
      hoverText: t('nosotros.carousel.img3.hoverText'),
      hoverDate: t('nosotros.carousel.img3.hoverDate')
    },
    {
      url: carrouselImages[3],
      caption: t('nosotros.carousel.img4.caption'),
      hoverText: t('nosotros.carousel.img4.hoverText'),
      hoverDate: t('nosotros.carousel.img4.hoverDate')
    },
    {
      url: carrouselImages[4],
      caption: t('nosotros.carousel.img5.caption'),
      hoverText: t('nosotros.carousel.img5.hoverText'),
      hoverDate: t('nosotros.carousel.img5.hoverDate')
    },
    {
      url: carrouselImages[5],
      caption: t('nosotros.carousel.img6.caption'),
      hoverText: t('nosotros.carousel.img6.hoverText'),
      hoverDate: t('nosotros.carousel.img6.hoverDate')
    },
    {
      url: carrouselImages[6],
      caption: t('nosotros.carousel.img7.caption'),
      hoverText: t('nosotros.carousel.img7.hoverText'),
      hoverDate: t('nosotros.carousel.img7.hoverDate')
    },
    {
      url: carrouselImages[7],
      caption: t('nosotros.carousel.img8.caption'),
      hoverText: t('nosotros.carousel.img8.hoverText'),
      hoverDate: t('nosotros.carousel.img8.hoverDate')
    },
    {
      url: carrouselImages[8],
      caption: t('nosotros.carousel.img9.caption'),
      hoverText: t('nosotros.carousel.img9.hoverText'),
      hoverDate: t('nosotros.carousel.img9.hoverDate')
    },
    {
      url: carrouselImages[9],
      caption: t('nosotros.carousel.img10.caption'),
      hoverText: t('nosotros.carousel.img10.hoverText'),
      hoverDate: t('nosotros.carousel.img10.hoverDate')
    },
    {
      url: carrouselImages[10],
      caption: t('nosotros.carousel.img11.caption'),
      hoverText: t('nosotros.carousel.img11.hoverText'),
      hoverDate: t('nosotros.carousel.img11.hoverDate')
    },
    {
      url: carrouselImages[11],
      caption: t('nosotros.carousel.img12.caption'),
      hoverText: t('nosotros.carousel.img12.hoverText'),
      hoverDate: t('nosotros.carousel.img12.hoverDate')
    },
    {
      url: carrouselImages[12],
      caption: t('nosotros.carousel.img13.caption'),
      hoverText: t('nosotros.carousel.img13.hoverText'),
      hoverDate: t('nosotros.carousel.img13.hoverDate')
    },
    {
      url: carrouselImages[13],
      caption: t('nosotros.carousel.img14.caption'),
      hoverText: t('nosotros.carousel.img14.hoverText'),
      hoverDate: t('nosotros.carousel.img14.hoverDate')
    },
    {
      url: carrouselImages[14],
      caption: t('nosotros.carousel.img15.caption'),
      hoverText: t('nosotros.carousel.img15.hoverText'),
      hoverDate: t('nosotros.carousel.img15.hoverDate')
    },
    {
      url: carrouselImages[15],
      caption: t('nosotros.carousel.img16.caption'),
      hoverText: t('nosotros.carousel.img16.hoverText'),
      hoverDate: t('nosotros.carousel.img16.hoverDate')
    }
  ];
  
  return (
    <div>
      <PetalRain />
      {/* Hero Section with Background Image */}
      <Segment
        inverted
        textAlign='center'
        className="nosotros-hero-segment"
        vertical
      >
        {/* Background image with blur */}
        <div className="nosotros-hero-background" style={{ backgroundImage: `url(${heroImage})` }} />
        
        {/* Dark overlay */}
        <div className="nosotros-hero-overlay" />
        
        <Container className="nosotros-hero-container">
          <Header
            as='h1'
            inverted
            className="nosotros-hero-title"
          >
            {t('aboutUs.title')}
          </Header>
          
          {/* Quotes dentro del hero */}
          <div className="nosotros-quotes-wrapper">
            <Quote 
              text={t('nosotros.quote1')}
              author="Aurel"
              align="left"
              backgroundColor="transparent"
              inverted={true}
            />

            <Quote 
              text={t('nosotros.quote2')}
              author="Dennys"
              align="right"
              backgroundColor="transparent"
              inverted={true}
            />
          </div>
        </Container>
      </Segment>
      
      <WeddingDivider />

      <div className="nosotros-content-wrapper">
        <StorySection 
          imageUrl={storyImage}
          title={t('nosotros.storyTitle')}
          text={t('nosotros.storyText')}
          orientation="left"
        />
      </div>

      <WeddingDivider />

      <div className="nosotros-carousel-wrapper">
        <p className="narrative-intro">{t('nosotros.carouselIntro')}</p>
        <ImageCarousel images={carouselImages} autoplayInterval={5000} />
      </div>
    </div>
  );
}

export default Nosotros;
